import { Group, Menu, rem, UnstyledButton } from '@mantine/core';
import { IconChevronDown, IconLogout, IconUser } from '@tabler/icons-react';
import { AccountService } from '@bobex/react-core/services/AccountService';
import { useTranslation } from 'react-i18next';

export default function UserMenu() {
  const { t } = useTranslation();
  const user = AccountService.getUser();

  return (
    <Menu
      width={260}
      position="bottom-end"
      transitionProps={{ transition: 'pop-top-right' }}
      withinPortal
    >
      <Menu.Target>
        <UnstyledButton>
          <Group gap={7}>
            <IconUser style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
            {user && (
              <>
                {user.firstname} {user.lastname}
              </>
            )}
            <IconChevronDown style={{ width: rem(12), height: rem(12) }} stroke={1.5} />
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={
            <IconLogout style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
          }
          onClick={() => {
            AccountService.logout();
          }}
        >
          {t('Logout')}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
